import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const WarehousePage = () => <Guide content={guides.warehouse} />
